<main class="subscribe-page-main" aria-label="API subscription page">
  <section class="subscribe-page-inner" aria-labelledby="subscribe-page-title">
    <h1 id="subscribe-page-title" class="subscribe-page-title mr-0">Add API</h1>
    <div class="subscribe-page-form-div">
      <kp-api-subscribe [apiData]="selectedApiDetails" [applicationsData]="applicationsData"></kp-api-subscribe>
    </div>
  </section>
</main>
